import { useParams } from '@tanstack/react-router';

/**
 * Returns the current orgPid from the URL path parameter.
 * Must be called from within a `/$orgPid/*` route.
 */
export function useOrgParam(): string {
  const { orgPid } = useParams({ strict: false }) as { orgPid: string };
  return orgPid;
}
